// @intl project:microsite

import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import classnames from 'classnames'
import { useTheme } from 'styled-components/native'

import DefaultButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/defaultButton/DefaultButton'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { PrimaryButton } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/primaryButton/PrimaryButton'
import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { BaseModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/baseModal/BaseModal'
import { TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import styles from './legalNotice.module.scss'

type CoverageTermsContentProps = {
  legalLanguage: React.ReactNode
}

export const CoverageTermsContent = ({ legalLanguage }: CoverageTermsContentProps) => {
  const [isCoverageModalOpen, setCoverageModalVisibility] = useState(false)
  const intl = useIntl()
  const { colors } = useTheme() as ThemeType

  const modalContent = (
    <div>
      <div className={styles['coverage-title']}>
        <Title
          size={TitleSize.LARGE}
          text={intl.formatMessage({
            defaultMessage: 'Coverage',
            description: 'Title text for a modal dialog displaying legal language about service coverage',
          })}
        />
      </div>
      <BodyText color={colors.textPrimary}>{legalLanguage}</BodyText>
      <div className={classnames(styles['coverage-close-btn'])}>
        <PrimaryButton
          testID={tID('Coverage-Modal-Close-Btn')}
          onPress={() => setCoverageModalVisibility(false)}
          text={
            <FormattedMessage
              defaultMessage='Close'
              description='Button to close a modal dialog displaying legal language about service coverage'
            />
          }
        />
      </div>
    </div>
  )
  return (
    <>
      <BaseModal
        data-test-id='Legal-Coverage-Modal'
        isOpen={isCoverageModalOpen}
        body={modalContent}
        closeModal={() => setCoverageModalVisibility(false)}
        size={'medium'}
        showCloseButton
      />
      <DefaultButton
        unstyled
        data-test-id='Coverage-Link-Btn'
        onClick={() => setCoverageModalVisibility(true)}
        customClass={classnames(styles['coverage-modal-link'])}
      >
        <FormattedMessage
          defaultMessage='Coverage'
          description='Link to legal language about service coverage. Displayed on the footer of all client pages next to other legal links.'
        />
      </DefaultButton>
    </>
  )
}
